var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6334 9.99C21.6434 13.35 19.0034 16.02 15.6634 16.02H15.6534C12.2434 16.03 9.59339 13.38 9.59339 9.99C9.6034 6.65 12.2634 4 15.6134 4C18.9834 4 21.6334 6.64 21.6334 9.99ZM19.9134 9.98C19.9134 7.64 17.9734 5.72 15.6234 5.72H15.6334C13.2834 5.71 11.3434 7.63 11.3434 9.98C11.3334 12.38 13.2534 14.27 15.6734 14.27C18.0334 14.26 19.9134 12.36 19.9134 9.98Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2434 18.8199C23.5034 19.6799 24.4034 20.8099 24.5734 22.3799C24.7634 24.1699 23.9634 25.5299 22.6134 26.6199C20.9234 27.9899 18.4334 28.7399 15.3734 28.7399C13.2234 28.6699 10.8234 28.1599 8.8234 26.4599C6.33341 24.3399 6.40339 21.1499 8.97339 19.1199C10.9234 17.5799 13.2034 17.0299 15.6434 16.9899C18.0134 16.9599 20.2634 17.4499 22.2434 18.8199ZM15.6334 26.9999C17.5634 26.9899 19.2834 26.6399 20.8534 25.7199H20.8634C23.5034 24.1699 23.5534 21.6299 20.9434 20.0499C18.6734 18.6899 16.2034 18.4599 13.6434 18.9399C12.1534 19.2199 10.7634 19.7399 9.6734 20.8599C8.4834 22.0699 8.4534 23.5299 9.6034 24.7799C9.89341 25.0999 10.2534 25.3899 10.6234 25.6199C12.1934 26.6199 13.9434 26.9599 15.6334 26.9999Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.b21570e54faa04e7182e22e5a84c1a2d.svg";
export { ForwardRef as ReactComponent };